module.exports = __webpack_public_path__ + "static/media/Pin_Tow-Truck-icon.02711e7e.svg";